import { ModalProps } from "@/components/Modal/types";
import { tw } from "@/utils";
import CloseIcon from "./closeIcon.svg?react";
import { ICUBarChart } from "./ICUBarChart";
import { hospitalCodeToName } from "@/data/hospital";
import { useGetICUResource } from "../api";

interface ICUModalProps extends ModalProps {
  hospitalCode: string;
}

export const ICUModal = (props: ICUModalProps) => {
  const { onClose, hospitalCode } = props;

  const { data, isSuccess, isLoading, isError } =
    useGetICUResource(hospitalCode);

  return (
    <div className="w-fit max-w-full h-fit bg-white rounded-[16px]">
      {/* header */}
      <div
        className={tw(
          "w-full h-[76px] px-[24px] flex items-center gap-[10px]",
          "border-solid border-b-[1px] border-gray-g30"
        )}
      >
        <div
          className={tw(
            "flex items-center w-fit h-[36px] px-[12px] bg-purple-30 rounded-[6px]",
            "text-base font-semibold text-purple-100"
          )}
        >
          {hospitalCodeToName[hospitalCode]}
        </div>
        <div className="text-xl font-semibold text-gray-g300">
          ICU 잔여율 현황
        </div>
        <div className="text-base font-regular text-gray-g100">
          우리 병원 전체 ICU 병상 잔여율 현황입니다.
        </div>
        <button className="ml-auto" onClick={onClose}>
          <CloseIcon />
        </button>
      </div>
      {/* body */}
      <div className="w-full h-fit p-[24px] pt-[18px]">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-[50px]">
            <div className="flex items-center gap-[8px]">
              <div className="w-[12px] h-[12px] bg-gray-g30 rounded-[2px]" />
              <div className="text-lg font-medium text-gray-g400">1시간 전</div>
            </div>
            <div className="flex items-center gap-[8px]">
              <div className="w-[12px] h-[12px] bg-purple-100 rounded-[2px]" />
              <div className="text-lg font-medium text-gray-g400">현재</div>
            </div>
          </div>
          <div className="flex items-center gap-[32px]">
            <div className="flex items-center gap-[8px]">
              <div className="w-[10px] aspect-square rounded-full bg-green" />
              <div className="text-lg font-medium text-gray-g400">원활</div>
            </div>
            <div className="flex items-center gap-[8px]">
              <div className="w-[10px] aspect-square rounded-full bg-yellow" />
              <div className="text-lg font-medium text-gray-g400">보통</div>
            </div>
            <div className="flex items-center gap-[8px]">
              <div className="w-[10px] aspect-square rounded-full bg-red" />
              <div className="text-lg font-medium text-gray-g400">혼잡</div>
            </div>
          </div>
        </div>
        <div className="relative w-full mt-[16px] overflow-auto">
          {/* <div className="absolute"></div> */}
          {isSuccess && <ICUBarChart resource={data.result.data} />}
        </div>
        <div className="flex mt-[42px] w-full h-[42px]">
          <button
            className={tw(
              "flex items-center justify-center w-[108px] h-[42px] ml-auto bg-gray-g300 rounded-[8px]",
              "text-base font-semibold text-white"
            )}
            onClick={onClose}
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
};
